import "../_dev.js";
//#region src/function/debounce.ts
function e(e, t = 300, n = {
	leading: !1,
	trailing: !0
}) {
	let r = n.leading ?? !1, i = n.trailing ?? !0, a, o, s, c = !1, l = () => {
		a !== void 0 && (clearTimeout(a), a = void 0);
	}, u = () => {
		if (l(), c = !1, !o) return;
		let t = o;
		return o = void 0, s = e(...t), s;
	};
	return Object.assign((...n) => (o = n, r && !c && (c = !0, s = e(...n), o = void 0, !i) ? (a = setTimeout(() => {
		a = void 0, c = !1;
	}, t), s) : r && !i && c ? s : (l(), a = setTimeout(u, t), s)), {
		cancel: () => {
			l(), o = void 0, c = !1;
		},
		flush: () => u(),
		pending: () => a !== void 0
	});
}
//#endregion
export { e as debounce };

//# sourceMappingURL=debounce.js.map